import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface OCClaimStatusOption {
  claimStatusCode: string;
  claimStatusDescription: string;
}

export const getOCClaimStatusAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.OVERCHARGE_CLAIM}/GetClaimStatus`,
  });
};

export type OCClaimStatusResponse = OCClaimStatusOption[];

export const fetchOCClaimStatus = async (): Promise<OCClaimStatusResponse> => {
  const response: AxiosResponse<OCClaimStatusResponse> = await getOCClaimStatusAPI();
  return response.data;
};
